<template>
  <div class="coupon-wrapper">
    <h3>我的礼券</h3>
    <p class="useList swiper-tab">
      <span :class="[currentTab==0 ? 'active' : '']" @click="tapNav(0)">未使用({{vaild_coupons.length}})</span>
      <span :class="[currentTab==1 ? 'active' : '']" @click="tapNav(1)">已使用({{used_coupons.length}})</span>
      <span :class="[currentTab==2 ? 'active' : '']" @click="tapNav(2)">已过期({{out_date_coupons.length}})</span>
    </p>
    <!-- 未使用优惠券 -->
    <div class="couponBox unUsed" v-if="currentTab==0">
      <div class="couponCon" v-for="(item, index) in vaild_coupons" :key="`unuse-${index}`">
        <dl>
          <template v-if="item.coupon_type == 'product_coupon'">
            <dt>
              <img class="product_coupon-image" :src="item.coupon_pic" :alt="item.desc" />
              <span class="coupon_msg">商品券</span>
            </dt>
            <dd>
              <h4 class="text--single_line">{{item.product_coupon_name}}</h4>
              <p v-if="!item.vaild_desc">{{ item.start | dateFmt | strLength(10) }} - {{ item.end | dateFmt | strLength(10) }}</p>
            </dd>
          </template>
          <template v-else-if="item.coupon_type == 'coupon_discount'">
            <dt>{{item.product_discount}}折</dt>
            <dd>
              <h4 class="text--single_line">{{item.desc}}</h4>
              <p>全场通用</p>
              <p v-if="item.vaild_desc">{{ item.vaild_desc }}</p>
              <p v-else>{{ item.start | dateFmt | strLength(10) }} - {{ item.end | dateFmt | strLength(10) }}</p>
            </dd>
          </template>
          <template v-else>
            <dt>￥{{item.price}}</dt>
            <dd>
              <h4 class="text--single_line">{{item.desc}}</h4>
              <p>满{{item.require}}可用，全场通用</p>
              <p v-if="item.vaild_desc">{{ item.vaild_desc }}</p>
              <p v-else>{{ item.start | dateFmt | strLength(10) }} - {{ item.end | dateFmt | strLength(10) }}</p>
            </dd>
          </template>
        </dl>
        <div class="useNow" @click="toHome">立即使用</div>
      </div>
      <!-- 暂无优惠券 -->
      <div :class="['noCoupon', vaild_coupons.length > 0 ? 'noShow' : '']">
        <div class="noCouponLeft">
          <dl>
            <dt>
              <i class="iconfont">&#xe687;</i>
            </dt>
            <dd>
              <h4>礼券信息</h4>
              <p>您还没有任何礼券</p>
            </dd>
          </dl>
        </div>
        <div class="noCouponRight">
          <router-link to="/">继续购物</router-link>
        </div>
      </div>
    </div>
    <!-- 已使用优惠券 -->
    <div class="couponBox used" v-if="currentTab==1">
      <div class="couponCon" v-for="(item, index) in used_coupons" :key="`used-${index}`">
        <dl>
          <template v-if="item.coupon_type == 'product_coupon'">
            <dt>
              <img class="product_coupon-image" :src="item.coupon_pic" :alt="item.desc" />
            </dt>
            <dd>
              <h4 class="text--single_line">{{item.product_coupon_name}}</h4>
              <p v-if="!item.vaild_desc">{{ item.start | dateFmt | strLength(10) }} - {{ item.end | dateFmt | strLength(10) }}</p>
            </dd>
          </template>
          <template v-else-if="item.coupon_type == 'coupon_discount'">
            <dt>{{item.product_discount}}折</dt>
            <dd>
              <h4 class="text--single_line">{{item.desc}}</h4>
              <p>全场通用</p>
              <p v-if="item.vaild_desc">{{ item.vaild_desc }}</p>
              <p v-else>{{ item.start | dateFmt | strLength(10) }} - {{ item.end | dateFmt | strLength(10) }}</p>
            </dd>
          </template>
          <template v-else>
            <dt>￥{{item.price}}</dt>
            <dd>
              <h4 class="text--single_line">{{item.desc}}</h4>
              <p>满{{item.require}}可用，全场通用</p>
              <p v-if="item.vaild_desc">{{ item.vaild_desc }}</p>
              <p v-else>{{ item.start | dateFmt | strLength(10) }} - {{ item.end | dateFmt | strLength(10) }}</p>
            </dd>
          </template>
        </dl>
        <div class="useNow not-allow">已使用</div>
      </div>
      <!-- 暂无优惠券 -->
      <div :class="['noCoupon', used_coupons.length > 0 ? 'noShow' : '']">
        <div class="noCouponLeft">
          <dl>
            <dt>
              <i class="iconfont">&#xe687;</i>
            </dt>
            <dd>
              <h4>礼券信息</h4>
              <p>您还没有任何礼券</p>
            </dd>
          </dl>
        </div>
        <div class="noCouponRight">
          <router-link to="/">继续购物</router-link>
        </div>
      </div>
    </div>
    <!-- 已过期优惠券 -->
    <div class="couponBox expired" v-if="currentTab==2">
      <div class="couponCon" v-for="(item, index) in out_date_coupons" :key="`expired-${index}`">
        <dl>
          <template v-if="item.coupon_type == 'product_coupon'">
            <dt>
              <img class="product_coupon-image" :src="item.coupon_pic" :alt="item.desc" />
            </dt>
            <dd>
              <h4 class="text--single_line">{{item.product_coupon_name}}</h4>
              <p v-if="!item.vaild_desc">{{ item.start | dateFmt | strLength(10) }} - {{ item.end | dateFmt | strLength(10) }}</p>
            </dd>
          </template>
          <template v-else-if="item.coupon_type == 'coupon_discount'">
            <dt>{{item.product_discount}}折</dt>
            <dd>
              <h4 class="text--single_line">{{item.desc}}</h4>
              <p>全场通用</p>
              <p v-if="item.vaild_desc">{{ item.vaild_desc }}</p>
              <p v-else>{{ item.start | dateFmt | strLength(10) }} - {{ item.end | dateFmt | strLength(10) }}</p>
            </dd>
          </template>
          <template v-else>
            <dt>￥{{item.price}}</dt>
            <dd>
              <h4 class="text--single_line">{{item.desc}}</h4>
              <p>满{{item.require}}可用，全场通用</p>
              <p v-if="item.vaild_desc">{{ item.vaild_desc }}</p>
              <p v-else>{{ item.start | dateFmt | strLength(10) }} - {{ item.end | dateFmt | strLength(10) }}</p>
            </dd>
          </template>
        </dl>
        <div class="useNow not-allow">已过期</div>
      </div>
      <!-- 暂无优惠券 -->
      <div :class="['noCoupon', out_date_coupons.length > 0 ? 'noShow' : '']">
        <div class="noCouponLeft">
          <dl>
            <dt>
              <i class="iconfont">&#xe687;</i>
            </dt>
            <dd>
              <h4>礼券信息</h4>
              <p>您还没有任何礼券</p>
            </dd>
          </dl>
        </div>
        <div class="noCouponRight">
          <router-link to="/">继续购物</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import types from '@/store/types';
import api from '@/utils/api';

export default {
  data() {
    return {
      currentTab: 0,
      vaild_coupons: [],
      used_coupons: [],
      out_date_coupons: []
    };
  },
  created() {
    this.loadSource();
  },
  methods: {
    loadSource() {
      api[types.COUPON_LIST]().then(res => {
        if (res.code == 1) {
          let { vaild_coupons, used_coupons, out_date_coupons } = res.data;
          this.vaild_coupons = vaild_coupons || [];
          this.used_coupons = used_coupons || [];
          this.out_date_coupons = out_date_coupons || [];
        } else if (res.code != 2) {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    tapNav(idx) {
      this.currentTab = idx;
    },
    toHome() {
      this.$router.push({ path: "/" });
    }
  },
  filters: {
    dateFmt(str) {
      return str?.replace(/-/g, '.');
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-wrapper {
  width: 100%; margin: 0 auto; padding: 0 18px;
  h3 { color: #333333; font-weight: bold; font-size: 1.125rem; padding: 1.6875rem 0 1.25rem 0; display: none; }
  .useList {
    display: flex;
    span {
      color: #666666; font-size: 0.875rem; width: 5.625rem; cursor: pointer;
      &.active { color: #333333; font-weight: 700; }
      &:nth-child(2) { border-right: 1px solid #666666; border-left: 1px solid #666666; text-align: center; }
      &:nth-child(3) { text-align: right; }
    }
  }
  .couponBox {
    display: flex; flex-wrap: wrap;
    .couponCon {
      width: 100%;
      background: rgba(255, 255, 254, 1);
      border: 0.0625rem solid rgba(223, 223, 223, 1);
      border-radius: 0.625rem;
      margin: 0 0 1.25rem 0;
      dl {
        display: flex; width: 100%; align-items: center; padding: 1.6875rem 1rem 0 1.0625rem;
        dt {
          width: 3.4375rem; margin-right: 1.1875rem; vertical-align: middle; font-size: 1.25rem; font-weight: 400; line-height: 1.75rem; position: relative;
          .product_coupon-image { min-width: 3.4375rem; height: auto; max-height: 68px; font-size: 12px; }
          .coupon_msg { position: absolute; bottom: 0; left: 0; width: 100%; height: 1rem; background: rgba(0, 0, 0, 0.5); font-size: 12px; color: #FFF; line-height: 1rem; text-align: center; }
        }
        dd {
          flex: 1;
          h4 { font-size: 1.125rem; font-weight: 500; line-height: 1.25rem; white-space: wrap;}
          p { margin: 0; font-weight: 300; font-size: 0.875rem; line-height: 1.25rem; }
        }
      }
      .useNow {
        border-top: 0.0625rem #dfdfdf dashed;
        width: 100%;
        text-align: center;
        padding: 0.9375rem 0;
        position: relative;
        cursor: pointer;
        &::before {
          content: "";
          position: absolute;
          left: -0.0625rem;
          top: -0.625rem;
          border-radius: 0 3.125rem 3.125rem 0;
          border-top: 0.0625rem solid rgba(223, 223, 223, 1);
          border-bottom: 0.0625rem solid rgba(223, 223, 223, 1);
          border-right: 0.0625rem solid rgba(223, 223, 223, 1);
          width: 0.625rem;
          height: 1.25rem;
          background: #ffffff;
        }
        &::after {
          content: "";
          position: absolute;
          right: -0.0625rem;
          top: -0.625rem;
          border-radius: 3.125rem 0 0 3.125rem;
          border-top: 0.0625rem solid rgba(223, 223, 223, 1);
          border-bottom: 0.0625rem solid rgba(223, 223, 223, 1);
          border-left: 0.0625rem solid rgba(223, 223, 223, 1);
          width: 0.625rem;
          height: 1.25rem;
          background: #ffffff;
        }
      }
    }
    &.unUsed .couponCon {
      dl {
        dt { color: rgba(76, 97, 73, 1); }
        dd {
          h4 { color: rgba(51, 51, 51, 1); }
          p { color: rgba(102, 102, 102, 1); }
        }
      }
      .useNow { color: rgba(51, 51, 51, 1); }
    }
    &.used .couponCon {
      dl {
        dt { color: rgba(153, 153, 153, 1); }
        dd {
          h4 { color: rgba(153, 153, 153, 1); }
          p { color: rgba(102, 102, 102, 1); }
        }
      }
      .useNow { color: rgba(153, 153, 153, 1); cursor: not-allowed; }
    }
    &.expired .couponCon {
      dl {
        dt { color: rgba(153, 153, 153, 1); }
        dd {
          h4 { color: rgba(153, 153, 153, 1); }
          p { color: rgba(102, 102, 102, 1); }
        }
      }
      .useNow { color: rgba(153, 153, 153, 1); cursor: not-allowed; }
    }
    .noCoupon {
      width: 100%;
      display: flex;
      justify-content: space-between; align-items: center;
      padding: 3.75rem 3.125rem;
      // border: 0.0625rem solid rgba(223, 223, 223, 1);
      &.noShow { display: none; }
      .noCouponLeft {
        display: flex; justify-content: flex-start; align-items: center;
        dl {
          display: flex; align-items: center;
          dt {
            display: inline-block; width: 5rem; height: 5rem; background: rgba(246, 246, 246, 1); border-radius: 50%;
            margin-bottom: 1.25rem;
            text-align: center;
            vertical-align: middle;
            .iconfont { font-size: 2.25rem; color: #c3c3c3; line-height: 5rem; }
          }
          dd {
            h4 { font-size: 1.25rem; color: rgba(0, 0, 0, 1); line-height: 1.25rem; font-weight: 500; }
            p { font-size: 0.875rem; color: rgba(102, 102, 102, 1); line-height: 0.875rem; font-weight: 400; }
          }
        }
      }
      .noCouponRight {
        a {
          // width: 10.875rem;
          display: inline-block;
          background: rgba(0, 0, 0, 1);
          border: 1px solid rgba(223, 223, 223, 1);
          text-align: center;
          color: #ffffff;
          font-size: 0.75rem;
          line-height: 1;
          border-radius: 3.125rem;
          padding: 0.8125rem 1.875rem;
          vertical-align: middle;
          text-decoration: none;
        }
      }
    }
  }
}
@media screen and (max-width: 48em) {
  .coupon-wrapper .couponBox .noCoupon{
    margin: 0 auto;
    flex-direction: column;
    align-items: center;
    .noCouponLeft{
      dl{
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
    }
  }
}
@media screen and (min-width: 48em) {
  .coupon-wrapper {
    h3 { display: block; }
    .couponBox {
      .couponCon {
        width: calc((100% - 1.25rem) / 2); margin: 0 1.25rem 1.25rem 0;
        &:nth-child(2n) { margin-right: 0; }
      }
      .noCoupon {
        border: 0.0625rem solid rgba(223, 223, 223, 1);
        .noCouponLeft {
          dl {
            margin-bottom: 0;
            dt { margin-bottom: 0; margin-right: 1rem; }
            dd {
              p { margin-bottom: 0; }
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 75em) {
  .coupon-wrapper {
    .couponBox {
      .couponCon {
        width: calc((100% - 2.5rem) / 3);
        &:nth-child(2n) { margin-right: 1.25rem; }
        &:nth-child(3n) { margin-right: 0; }
        dl {
          dd {
            h4 { font-size: 1.125rem; font-weight: 500; line-height: 1.25rem; max-width: 189px; white-space: nowrap;}
          }
        }
      }
    }
  }
}
</style>